module.exports = __webpack_public_path__ + "static/img/co2.2369a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/co2.png
// module id = 0pRz
// module chunks = 1